import axios from "axios";
import { API_BASE_URL } from "./config";

const api = axios.create({
    baseURL: `${API_BASE_URL}/api/auth`,
    withCredentials: true,
});

export const registerUser = async (credentials) => {
    return await api.post("/signup", credentials);
};

export const loginUser = async (credentials) => {
    return await api.post("/signin", credentials);
};

export const logoutUser = async () => {
    return await api.post("/logout");
};

// Restores an existing session using the HTTP-only access_token cookie
// (sent automatically because of withCredentials: true above).
export const checkAuth = async () => {
    return await api.get("/verify");
};

export const sendEmailForForgotPassword = async (email) => {
    return await api.post("/forgotpassword", email);
};

export const resetPassword = async (token, data) => {
    return await api.post(`/password/reset/${token}`, data);
};